export default function Cookie() {
  return (
    <section className="py-20 bg-white">
      <div className="max-w-3xl mx-auto px-5 lg:px-10 prose prose-neutral">
        <h1 className="font-display uppercase text-4xl text-drosun-text">Cookie Policy</h1>
        <p className="text-drosun-muted">Ultimo aggiornamento: {new Date().toLocaleDateString("it-IT")}</p>

        <p>Questo sito utilizza esclusivamente cookie tecnici necessari al corretto funzionamento del sito. Non vengono installati cookie di profilazione né di terze parti per finalità di marketing.</p>

        <h2 className="font-display uppercase text-2xl text-drosun-text mt-8">Cookie tecnici</h2>
        <p>Sono cookie indispensabili per la navigazione e l'utilizzo delle funzionalità del sito. Non richiedono il consenso preventivo.</p>

        <h2 className="font-display uppercase text-2xl text-drosun-text mt-6">Gestione delle preferenze</h2>
        <p>L'utente può in qualsiasi momento modificare le proprie preferenze tramite il banner cookie presente sul sito o cancellando i cookie dalle impostazioni del browser.</p>

        <h2 className="font-display uppercase text-2xl text-drosun-text mt-6">Contatti</h2>
        <p>Per richieste relative alla presente Cookie Policy: <a href="mailto:Europe@drosun-eu.com" className="text-drosun-red">Europe@drosun-eu.com</a>.</p>
      </div>
    </section>
  );
}
